module.exports = __webpack_public_path__ + "static/img/mediaCom.e78670b3.png";